import { BqApiProvider } from './../../providers/bq-api/bq-api';
import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController
} from 'ionic-angular';
import { ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { PresentationProductPage } from './../presentation-product/presentation-product';
import { XsellUpsellPage } from './../xsell-upsell/xsell-upsell';

@IonicPage()
@Component({
  selector: 'page-closing-sale',
  templateUrl: 'closing-sale.html'
})
export class ClosingSalePage {
  public p38aSelection: number;
  public p38bSelection: number;
  public p38cSelection: number;
  public p38dSelection: number;
  public p39aSelection: number;
  public p39bSelection: number;
  public p39cSelection: number;
  public p40aSelection: number;
  public p40bSelection: number;
  public p40cSelection: number;
  public p40dSelection: number;
  public p41Selection: number;
  public p42Selection: number;
  public p43Selection: number;

  public closingSaleComment: string;
  public currentProfile: string;

  constructor(
    private translate: TranslateService,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private bqApi: BqApiProvider
  ) {
    this.p38aSelection = 0;
    this.p38bSelection = 0;
    this.p38cSelection = 0;
    this.p38dSelection = 0;
    this.p39aSelection = 0;
    this.p39bSelection = 0;
    this.p39cSelection = 0;
    this.p40aSelection = 0;
    this.p40bSelection = 0;
    this.p40cSelection = 0;
    this.p40dSelection = 0;
    this.p41Selection = 0;
    this.p42Selection = 0;
    this.p43Selection = 0;

    this.closingSaleComment = '';
  }

  ionViewDidLoad() {
    this.p38aSelection = this.bqApi.getStep(38) || 0;
    this.p38bSelection = this.bqApi.getStep(381) || 0;
    this.p38cSelection = this.bqApi.getStep(382) || 0;
    this.p38dSelection = this.bqApi.getStep(383) || 0;

    this.p39aSelection = this.bqApi.getStep(39) || 0;
    this.p39bSelection = this.bqApi.getStep(391) || 0;
    this.p39cSelection = this.bqApi.getStep(392) || 0;

    this.p40aSelection = this.bqApi.getStep(40) || 0;
    this.p40bSelection = this.bqApi.getStep(401) || 0;
    this.p40cSelection = this.bqApi.getStep(402) || 0;
    this.p40dSelection = this.bqApi.getStep(403) || 0;

    this.p41Selection = this.bqApi.getStep(41) || 0;
    this.p42Selection = this.bqApi.getStep(42) || 0;
    this.p43Selection = this.bqApi.getStep(43) || 0;

    this.closingSaleComment = this.bqApi.getComment(5) || '';

    this.currentProfile = this.bqApi.getEverestData().profile;
  }

  updateSteps() {
    if (this.p38aSelection !== 0) {
      this.bqApi.setStep(38, this.p38aSelection);
    }

    if (this.p38bSelection !== 0) {
      this.bqApi.setStep(381, this.p38bSelection);
    }

    if (this.p38cSelection !== 0) {
      this.bqApi.setStep(382, this.p38cSelection);
    }

    if (this.p38dSelection !== 0) {
      this.bqApi.setStep(383, this.p38dSelection);
    }

    if (this.p39aSelection !== 0) {
      this.bqApi.setStep(39, this.p39aSelection);
    }

    if (this.p39bSelection !== 0) {
      this.bqApi.setStep(391, this.p39bSelection);
    }

    if (this.p39cSelection !== 0) {
      this.bqApi.setStep(392, this.p39cSelection);
    }
    if (this.p40aSelection !== 0) {
      this.bqApi.setStep(40, this.p40aSelection);
    }

    if (this.p40bSelection !== 0) {
      this.bqApi.setStep(401, this.p40bSelection);
    }

    if (this.p40cSelection !== 0) {
      this.bqApi.setStep(402, this.p40cSelection);
    }

    if (this.p40dSelection !== 0) {
      this.bqApi.setStep(403, this.p40dSelection);
    }

    if (this.p41Selection !== 0) {
      this.bqApi.setStep(41, this.p41Selection);
    }

    if (this.p42Selection !== 0) {
      this.bqApi.setStep(42, this.p42Selection);
    }

    if (this.p43Selection !== 0) {
      this.bqApi.setStep(43, this.p43Selection);
    }

    if( this.closingSaleComment ) {
      this.bqApi.setComment(5, this.closingSaleComment );
    }

    this.bqApi.syncSteps();
  }

  nextStep() {
    this.updateSteps();
    this.viewCtrl.dismiss();
    this.navCtrl.push(XsellUpsellPage);
  }

  previousStep() {
    this.updateSteps();
    this.viewCtrl.dismiss();
    this.navCtrl.push(PresentationProductPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/closing-sale/closing-sale.ts